(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 2734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTheme; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96682);
/* harmony import */ var _defaultTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90247);
/* harmony import */ var _identifier__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10606);




function useTheme() {
  const theme = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_defaultTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
  if (false) {}
  return theme[_identifier__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z] || theme;
}

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(48475);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41248);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7160);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _redux_Frontend_Help_redux_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5392);
/* harmony import */ var _redux_Frontend_Help_redux_selector__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24774);
/* harmony import */ var _CustomToast__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48509);








function StillSearching() {
    const form = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_redux_Frontend_Help_redux_selector__WEBPACK_IMPORTED_MODULE_4__/* .selectStillMakingRetreatsPlanForm */ .wP);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const handleFieldChange = (evt)=>{
        const { name , value  } = evt.target;
        dispatch(_redux_Frontend_Help_redux_slice__WEBPACK_IMPORTED_MODULE_3__/* .actions.updateStillMakingRetreatsPlanFormValue */ .Nw.updateStillMakingRetreatsPlanFormValue({
            key: name,
            value
        }));
    };
    const handleClick = ()=>{
        if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(form.email)) {
            (0,_CustomToast__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("Enter Valid Email ID", "ERROR");
            return;
        }
        dispatch(_redux_Frontend_Help_redux_slice__WEBPACK_IMPORTED_MODULE_3__/* .actions.stillMakingRetreatsPlan */ .Nw.stillMakingRetreatsPlan({
            callback: ()=>{
                dispatch(_redux_Frontend_Help_redux_slice__WEBPACK_IMPORTED_MODULE_3__/* .actions.clearStillMakingPlanForm */ .Nw.clearStillMakingPlanForm());
            }
        }));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_7___default().StillSearchingBg), " rounded bg-dark-blue mb-5 mt-3"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                className: "".concat((_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_7___default().StillSearching), "  px-4 px-xl-5 px-lg-5 px-md-5"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        lg: 6,
                        xs: 12,
                        className: "d-flex text-white ",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/images/mail.svg",
                                    className: "img-fluid",
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "ms-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                        className: "textUpperCase",
                                        children: "Still making your retreat plans?"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                        children: "Get goodness and inspiration delivered to your inbox via our weekly newsletter."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        lg: 6,
                        className: "".concat((_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_7___default().subscribe)),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "input-group d-flex d-lg-flex flex-lg-row col-12 ",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "col-12 col-sm-12 col-md-9 col-xl-10 ",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "d-flex flex-row align-items-center justify-content-start bg-white subscribe-email-input",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: "/images/email-icon.svg",
                                                    className: "col-lg col-md col-sm-3 ps-3 ps-md-1 ps-lg-1 img-lg-fluid email-img"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                    type: "email",
                                                    className: " border-0 subscribe-email-text col-sm-9 col-md-9 col-lg-11 ps-2 py-3 py-sm-3 py-md-3 py-lg-3",
                                                    placeholder: "Enter your email address",
                                                    "aria-label": "Recipient's email",
                                                    "aria-describedby": "button-addon2",
                                                    required: true,
                                                    value: form === null || form === void 0 ? void 0 : form.email,
                                                    name: "email",
                                                    onChange: handleFieldChange
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-white d-none d-md-block",
                                            children: "Note: We respect your privacy. We will not publish or share your email address in any way."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-12 col-sm-12 col-md-3 col-xl-2 mt-3 mt-md-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "subscribe-button subscribe-email-text bg-dark border-0 text-white fs-12 p-3 p-sm-3 p-md-3 p-lg-3 w-100 mt-lg-0 ",
                                        type: "button",
                                        id: "button-addon2",
                                        onClick: handleClick,
                                        children: "Subscribe"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (StillSearching);


/***/ }),

/***/ 45023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProductCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67814);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7160);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41248);
/* harmony import */ var _hooks_currencyshow__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30283);
/* harmony import */ var _utils_Api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93391);
/* harmony import */ var _redux_Frontend_WishList_redux_slice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32123);
/* harmony import */ var _redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30387);
/* harmony import */ var _redux_Login_redux_selector__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54549);
/* harmony import */ var _redux_School_SchoolPayments_redux_selector__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4657);




// import React, { useEffect } from 'react';








function ProductCard(props) {
    var _Number;
    const { overview , price , reviewScore , noOfReviews , photo , type , coupon , gift , retreatId , image , wishlistId , images , popular , seoTitle , seoActivityTitle  } = props;
    const [toggleWishlist, setToggleWhislist] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    // const router = useRouter();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (wishlistId) {
            setToggleWhislist(true);
        }
    }, [
        wishlistId
    ]);
    const handleToggle = ()=>{
        setToggleWhislist(!toggleWishlist);
    };
    const handleToggleRemove = ()=>setToggleWhislist(false);
    const handleShowSignin = ()=>{
        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_8__/* .actions.SignInFormShowHide */ .Nw.SignInFormShowHide(true));
    };
    const userType = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(_redux_Login_redux_selector__WEBPACK_IMPORTED_MODULE_9__/* .selectUserRole */ .nC);
    const handleWishlist = async (retreatId)=>{
        if (userType == 3) {
            handleToggle();
            if (!toggleWishlist) {
                dispatch(_redux_Frontend_WishList_redux_slice__WEBPACK_IMPORTED_MODULE_7__/* .actions.updateWishListFormValue */ .Nw.updateWishListFormValue({
                    key: "id",
                    value: retreatId
                }));
                dispatch(_redux_Frontend_WishList_redux_slice__WEBPACK_IMPORTED_MODULE_7__/* .actions.doAddWishlist */ .Nw.doAddWishlist({
                    callback: ()=>{
                        dispatch(_redux_Frontend_WishList_redux_slice__WEBPACK_IMPORTED_MODULE_7__/* .actions.doGetWishlist */ .Nw.doGetWishlist());
                        dispatch(_redux_Frontend_WishList_redux_slice__WEBPACK_IMPORTED_MODULE_7__/* .actions.toggalWishListIcon */ .Nw.toggalWishListIcon());
                    }
                }));
            } else {
                dispatch(_redux_Frontend_WishList_redux_slice__WEBPACK_IMPORTED_MODULE_7__/* .actions.doRemoveWishList */ .Nw.doRemoveWishList({
                    id: retreatId,
                    callback: ()=>{
                        dispatch(_redux_Frontend_WishList_redux_slice__WEBPACK_IMPORTED_MODULE_7__/* .actions.doGetWishlist */ .Nw.doGetWishlist());
                        dispatch(_redux_Frontend_WishList_redux_slice__WEBPACK_IMPORTED_MODULE_7__/* .actions.toggalWishListIcon */ .Nw.toggalWishListIcon());
                    }
                }));
            }
        } else {
            handleShowSignin();
        }
    };
    const Currencies = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(_redux_School_SchoolPayments_redux_selector__WEBPACK_IMPORTED_MODULE_10__/* .selectAllActiveCurrencyListData */ .IF);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "col-12 col-sm-6 col-lg-3 my-2 my-sm-2 my-md-2 my-lg-0 pe-md-2",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "fa-heart-wish-container pointer",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                        icon: [
                            "fas",
                            "heart"
                        ],
                        width: "19",
                        onClick: ()=>handleWishlist(retreatId),
                        style: {
                            color: toggleWishlist || wishlistId == 1 ? "#3165BA" : "#00000082",
                            cursor: "pointer"
                        },
                        className: "fa-heart-wish pointer"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: "/r/".concat(seoActivityTitle, "/").concat(seoTitle),
                    target: "_blank",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "col-lg-12 ".concat((_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_11___default().productCard), " mb-3 pointer h-100"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "".concat((_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_11___default().image_container), " d-none d-lg-block "),
                                style: {
                                    backgroundImage: " url(".concat((0,_utils_Api__WEBPACK_IMPORTED_MODULE_6__/* .path */ .E)()).concat(image, ")"),
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "cover",
                                    minHeight: "250px",
                                    maxHeight: "250px",
                                    position: "relative",
                                    backgroundPosition: "center center"
                                },
                                children: [
                                    popular == 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "badge-popular",
                                        children: "POPULAR"
                                    }) : gift == 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "badge-free-gift ",
                                        children: "FREE GIFT"
                                    }),
                                    coupon == 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "badge bg-primary p-2 m-1 ".concat((_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_11___default().coupon_badge)),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "fs-10 my-0",
                                            children: "Coupon Available"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "".concat((_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_11___default().image_container), " d-md-none d-block mb-3 img-fluid "),
                                style: {
                                    backgroundImage: " url(".concat((0,_utils_Api__WEBPACK_IMPORTED_MODULE_6__/* .path */ .E)()).concat(image, ")"),
                                    backgroundSize: "cover",
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center",
                                    minHeight: "320px",
                                    maxHeight: "400px",
                                    position: "relative"
                                },
                                children: [
                                    popular == 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "badge-popular",
                                        children: "POPULAR"
                                    }) : gift == 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "badge-free-gift fs-12",
                                        children: "FREE GIFT"
                                    }),
                                    coupon == 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "badge bg-primary p-2 m-1 ".concat((_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_11___default().coupon_badge)),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "fs-11 my-0",
                                            children: "Coupon Available"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "".concat((_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_11___default().image_container), " d-none d-lg-none d-md-block "),
                                style: {
                                    backgroundImage: " url(".concat((0,_utils_Api__WEBPACK_IMPORTED_MODULE_6__/* .path */ .E)()).concat(image, ")"),
                                    backgroundSize: "cover",
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center",
                                    minHeight: "250px",
                                    maxHeight: "250px",
                                    position: "relative"
                                },
                                children: [
                                    popular == 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "badge-popular",
                                        children: "POPULAR"
                                    }) : gift == 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "badge-free-gift ",
                                        children: "FREE GIFT"
                                    }),
                                    coupon == 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "badge bg-primary p-2 m-1 ".concat((_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_11___default().coupon_badge)),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "fs-10 my-0",
                                            children: "Coupon Available"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "d-flex justify-content-end"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "px-3 pt-2 black333",
                                style: {
                                    minHeight: "4.9rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "product-card-header textUpperCase",
                                        children: type ? type : "AYURVEDIC RETRETAS"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                        className: "fs-12 mt-2 mb-0 ",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "retreat-fs-13 text-decoration-none fw-500 black333 textUpperCase text-wrap2",
                                            style: {
                                                lineHeight: "1.44!important"
                                            },
                                            children: overview ? (overview === null || overview === void 0 ? void 0 : overview.length) > 80 ? "".concat(overview === null || overview === void 0 ? void 0 : overview.slice(0, 50), "...") : overview : ""
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "col-12 d-flex flex-row justify-content-between px-3 my-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "col-lg-6 d-flex flex-column justify-content-end",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "".concat((_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_11___default().rating), " p-0 d-flex align-items-center mb-1"),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                    icon: [
                                                        "fas",
                                                        "star"
                                                    ],
                                                    width: "14",
                                                    className: "m-0 retreat-text"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    className: "p-0 fs-10 fw-500 m-0 ms-2",
                                                    children: [
                                                        Number(reviewScore.toFixed(1)),
                                                        "/5",
                                                        " ",
                                                        noOfReviews > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                            children: [
                                                                " (",
                                                                noOfReviews,
                                                                ")"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "col-lg-6 d-flex align-items-end justify-content-end flex-column",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                                                className: "fs-10 paragraph",
                                                children: "From"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hooks_currencyshow__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                value: (_Number = Number(price)) === null || _Number === void 0 ? void 0 : _Number.toFixed(0),
                                                type: Currencies,
                                                className: "fs-6 fw-semibold text-dark"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 48475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./styles/Home.module.css
var Home_module = __webpack_require__(7160);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./components/layout/main-layout/index.tsx
var main_layout = __webpack_require__(37303);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/product-card.tsx
var product_card = __webpack_require__(45023);
// EXTERNAL MODULE: ./components/ReviewBlock.tsx + 1 modules
var ReviewBlock = __webpack_require__(45264);
// EXTERNAL MODULE: ./components/UI/Search.tsx + 1 modules
var Search = __webpack_require__(84659);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(41248);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/UI/DiscoverRetreats .tsx





function DiscoverRetreats() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                className: "mt-3 mt-sm-3 mt-md-5 mt-lg-5",
                children: [
                    discoverRetreats.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 4,
                            xl: 3,
                            className: "d-none d-md-block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                className: "".concat((Home_module_default()).discoverRetreats),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xs: 4,
                                        className: "pe-0 text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: item.img,
                                            alt: "Picture of the author",
                                            width: 88,
                                            height: 88,
                                            className: "img-fluid byr-discover-retreat-image"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                        xs: 8,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                className: " mb-1",
                                                children: item.heading
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                className: "m-0 text-title-black ",
                                                children: item.text
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, i)),
                    discoverRetreats.slice(0, 4).map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 4,
                            xl: 3,
                            className: "mt-2 d-block d-md-none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                className: "".concat((Home_module_default()).discoverRetreats),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xs: 3,
                                        sm: 4,
                                        className: "pe-0 text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: item.img,
                                            alt: "Picture of the author",
                                            width: 88,
                                            height: 88,
                                            className: "img-fluid byr-discover-retreat-image"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                        xs: 9,
                                        sm: 8,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                className: " ",
                                                children: item.heading
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                className: "m-0 text-title-black",
                                                children: item.text
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, i))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row mt-3 mt-sm-3 mt-md-5 mt-lg-5"
            })
        ]
    });
}
/* harmony default export */ var DiscoverRetreats_ = (DiscoverRetreats);
const discoverRetreats = [
    {
        img: "/images/luxury-retreat.jpg",
        heading: "Luxury Retreats",
        text: "Soak in the most magnificent views with yoga therapies."
    },
    {
        img: "/images/ayurvedic-retreat.jpg",
        heading: "Ayurvedic Retreats",
        text: "Experience the ancient healing therapies & rejuvenate."
    },
    {
        img: "/images/yoga-tour.jpg",
        heading: "Yoga Tours & Cruises",
        text: "Quality yoga retreats at unseen destinations & surreal views."
    },
    {
        img: "/images/yoga-holidays.jpg",
        heading: "Yoga Holidays",
        text: "Enjoy the vacation season with relaxing yoga retreats."
    },
    {
        img: "/images/affordable-yoga.jpg",
        heading: "Affordable Yoga Retreats",
        text: "It’s never too late to pick your favorite & cost-effective retreat."
    },
    {
        img: "/images/health-retreat.jpg",
        heading: "Health Retreats",
        text: "Both physical and mental healing starts within you; heal with the most recommended retreats."
    },
    {
        img: "/images/yoga-surf.jpg",
        heading: "Yoga & Surf",
        text: "Who said yoga isn’t fun & exciting? Revel in the adventurous side of yoga retreats."
    },
    {
        img: "/images/yoga-tour1.jpg",
        heading: "Yoga for Mind",
        text: "Don’t escape stress; go for the dedicated mind-yoga retreats & come back stronger."
    }
];

// EXTERNAL MODULE: ./components/UI/StillSearching.tsx
var StillSearching = __webpack_require__(55330);
// EXTERNAL MODULE: ./utils/Api.tsx
var Api = __webpack_require__(93391);
// EXTERNAL MODULE: ./redux/Frontend/ListingsFilter/redux/slice.tsx
var slice = __webpack_require__(2576);
// EXTERNAL MODULE: ./redux/Frontend/ListingsFilter/types.tsx
var types = __webpack_require__(6421);
;// CONCATENATED MODULE: ./components/UniqueExperiencesSec.tsx







function UniqueExperiencesSec() {
    const router = (0,next_router.useRouter)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const _handleroute = (retreatTypeFilter, activityFilter)=>{
        var _qr_activityFilter;
        let qr = {
            retreatTypeFilter,
            activityFilter
        };
        !qr.retreatTypeFilter && delete qr.retreatTypeFilter;
        !qr.activityFilter && delete qr.activityFilter;
        dispatch(slice/* actions.updateListingsFilterFormValue */.Nw.updateListingsFilterFormValue({
            key: "retreatTypeFilter",
            value: parseInt(qr.retreatTypeFilter) || []
        }));
        if (((_qr_activityFilter = qr.activityFilter) === null || _qr_activityFilter === void 0 ? void 0 : _qr_activityFilter.length) > 0) {
            dispatch(slice/* actions.setActivityList */.Nw.setActivityList(qr.activityFilter));
        }
        router.push({
            pathname: "/listing",
            query: qr
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "row mt-3 mt-md-5",
            id: "byr-safe-travel-row",
            children: UniqueExperiences.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-6 col-sm-6 col-lg-3 pt-3 pt-sm-4 pt-lg-0 pointer",
                    onClick: ()=>_handleroute(item.retreatTypeFilter, item.activityFilter),
                    style: {
                        position: "relative"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "imageContainer byr-image-rounder-homepage unique-experience-image rounded",
                            style: {
                                overflow: "hidden",
                                height: "100%"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: item.img,
                                alt: "Picture of the author",
                                width: 276,
                                height: 276,
                                style: {
                                    minHeight: "100%"
                                },
                                className: "img-fluid byr-category-image-list"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "byr-homepage-overlap-text-wrap",
                            style: {
                                position: "absolute",
                                bottom: "0"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-white fw-500 ms-sm-2 ms-md-3 pointer unique-experience",
                                children: item.title
                            })
                        })
                    ]
                }, i))
        })
    });
}
/* harmony default export */ var components_UniqueExperiencesSec = (UniqueExperiencesSec);
const UniqueExperiences = [
    {
        img: "/images/productImage2.jpg",
        title: "Yoga Retreat",
        retreatTypeFilter: "".concat(types/* RetreatsTypeEnum.Offline */.zZ.Offline),
        activityFilter: "Yoga Retreat"
    },
    {
        img: "/images/productimage.jpg",
        title: "Yoga Teacher Training",
        retreatTypeFilter: "".concat(types/* RetreatsTypeEnum.Offline */.zZ.Offline),
        activityFilter: "Yoga Teacher Training"
    },
    {
        img: "/images/productImage1.jpg",
        title: "Online Yoga Retreat",
        retreatTypeFilter: "".concat(types/* RetreatsTypeEnum.Online */.zZ.Online),
        activityFilter: "Yoga Retreat"
    },
    {
        img: "/images/productImage4.jpg",
        title: "Online Yoga Training",
        retreatTypeFilter: "".concat(types/* RetreatsTypeEnum.Online */.zZ.Online),
        activityFilter: "Yoga Teacher Training"
    }
];

// EXTERNAL MODULE: ./redux/Admin/SettingSection/SiteSetting/redux/slice.tsx
var redux_slice = __webpack_require__(62779);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
// EXTERNAL MODULE: ./redux/Login/redux/selector.tsx
var selector = __webpack_require__(54549);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./environment.tsx
var environment = __webpack_require__(58034);
;// CONCATENATED MODULE: ./pages/index.tsx





















var __N_SSP = true;
function Home(param) {
    let { data , adminsideData , title , description  } = param;
    const router = (0,next_router.useRouter)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const [showChild, setShowChild] = (0,react.useState)(false);
    const _handleroute = (retreatTypeFilter, activityFilter)=>{
        let qr = {
            retreatTypeFilter,
            activityFilter
        };
        !qr.retreatTypeFilter && delete qr.retreatTypeFilter;
        !qr.activityFilter && delete qr.activityFilter;
        dispatch(slice/* actions.updateListingsFilterFormValue */.Nw.updateListingsFilterFormValue({
            key: "retreatTypeFilter",
            value: parseInt(qr.retreatTypeFilter) || []
        }));
        dispatch(slice/* actions.updateListingsFilterFormValue */.Nw.updateListingsFilterFormValue({
            key: "activityFilter",
            value: qr.activityFilter
        }));
        dispatch(slice/* actions.updateListingsFilterFormValue */.Nw.updateListingsFilterFormValue({
            key: "sortData",
            value: types/* RetreatSortTypeEnum.Recommended */.gt.Recommended
        }));
        router.push({
            pathname: "/listing",
            query: qr
        });
    };
    const _handleChange = ()=>{
        dispatch(slice/* actions.setHandelChange */.Nw.setHandelChange(1));
    };
    const handleFeatured = (evt, activityFilter)=>{
        var _qr_activityFilter;
        let qr = {
            retreatFeatured: evt,
            activityFilter
        };
        dispatch(slice/* actions.updateListingsFilterFormValue */.Nw.updateListingsFilterFormValue({
            key: "retreatFeatured",
            value: evt
        }));
        if (((_qr_activityFilter = qr.activityFilter) === null || _qr_activityFilter === void 0 ? void 0 : _qr_activityFilter.length) > 0) {
            dispatch(slice/* actions.setActivityList */.Nw.setActivityList(qr.activityFilter));
        }
        router.push({
            pathname: "/listing",
            query: qr
        });
    };
    (0,react.useEffect)(()=>{
        setShowChild(true);
    }, []);
    const fetchImageData = ()=>{
        dispatch(redux_slice/* actions.doGetSiteSettingList */.Nw.doGetSiteSettingList());
    };
    (0,react.useEffect)(()=>{
        fetchImageData();
    }, []);
    const LoggedinUser = (0,es/* useSelector */.v9)(selector/* selectSchoolId */.KG);
    const unique_id = (0,v4/* default */.Z)();
    let id = "";
    (0,react.useEffect)(()=>{
        id = localStorage.getItem("userid");
        return ()=>{};
    }, []);
    let token = "";
    (0,react.useEffect)(()=>{
        token = localStorage.getItem("token");
        return ()=>{};
    }, []);
    (0,react.useEffect)(()=>{
        dispatch(redux_slice/* actions.setPageNo */.Nw.setPageNo(1));
        dispatch(redux_slice/* actions.doGetSiteSettingList */.Nw.doGetSiteSettingList());
        return ()=>{};
    }, []);
    (0,react.useEffect)(()=>{
        if (token) {
            localStorage.setItem("userid", LoggedinUser);
        } else {
            if (!id) {
                localStorage.setItem("userid", unique_id);
            } else {
                return;
            }
        }
    }, [
        LoggedinUser,
        token
    ]);
    if (!showChild) {
        return null;
    }
    if (false) {} else {
        var _data_featuredRetreats, _data_featuredTeacherTraining;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                    title: title,
                    description: description,
                    canonical: environment/* BASE_URL */._n,
                    openGraph: {
                        url: router.pathname,
                        title: "Book Your Next Yoga Retreat & Enjoy A Trusted Experience.",
                        description: "Experience the most amazing yoga retreats with 100+ retreat options available at Book Your Retreat. Check with reviews and get trusted feedback before booking. ",
                        images: [
                            {
                                url: "".concat((0,Api/* path */.E)()).concat(adminsideData.favicon)
                            }
                        ],
                        siteName: "Yoga Retreat"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(main_layout/* default */.Z, {
                    currencshow: true,
                    adminsideData: adminsideData,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "main-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                                className: "".concat((Home_module_default()).main, " pt-5"),
                                style: {
                                    backgroundImage: "url(".concat((0,Api/* path */.E)()).concat(adminsideData.homepageImage, ")"),
                                    position: "relative"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        position: "absolute",
                                        background: "rgb(0 0 0 /38%)",
                                        width: "100%",
                                        height: "100%",
                                        top: 0,
                                        // display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((Home_module_default()).headerContainer),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "container",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                        className: "header-title text-white fw-bold text-center text-capitalize",
                                                        children: "Break Free From Routine."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "mt-1 text-white header-paragraph text-center fw-500 px-sm-5 px-md-2 px-lg-0 text-capitalize",
                                                        children: "Enrich Your Life with Unforgettable Retreats and Yoga Teacher Training Programs"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "container mt-3 mt-sm-5 byr-category-button-wrap",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "row",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col-sm-0 col-lg-1 col-xl-2 col-12"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col-sm-12 col-lg-10 col-xl-8 col-12",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "row p-0 mb-2",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: " scroll-bar d-flex justify-content-between flex-wrap ",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "text-center mt-2 byr-banner-button-categories",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: "fw-semibold byr-banner-yoga-categories textmobile text-white BottomBorder text-underline pointer mb-0",
                                                                                    style: {
                                                                                        textShadow: ".3px 0px #ffffff"
                                                                                    },
                                                                                    onClick: ()=>_handleroute(types/* RetreatsTypeEnum.Offline */.zZ.Offline, "Yoga Retreat"),
                                                                                    children: "Yoga Retreat"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "text-center mt-2 byr-banner-button-categories",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: "textmobile byr-banner-yoga-categories fw-semibold BottomBorder text-white pointer mb-0",
                                                                                    style: {
                                                                                        textShadow: ".3px 0px #ffffff"
                                                                                    },
                                                                                    onClick: ()=>_handleroute(types/* RetreatsTypeEnum.Offline */.zZ.Offline, "Yoga Teacher Training"),
                                                                                    children: "Yoga Teacher Training"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "text-center mt-2 byr-banner-button-categories",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                    className: "textmobile byr-banner-yoga-categories fw-semibold text-white pointer mb-0",
                                                                                    style: {
                                                                                        textShadow: ".3px 0px #ffffff"
                                                                                    },
                                                                                    onClick: ()=>_handleroute(types/* RetreatsTypeEnum.Online */.zZ.Online, "Yoga Retreat"),
                                                                                    children: [
                                                                                        " ",
                                                                                        "Yoga Online Retreats"
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "text-center mt-2 byr-banner-button-categories",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: "textmobile byr-banner-yoga-categories fw-semibold text-white pointer mb-0",
                                                                                    style: {
                                                                                        textShadow: ".3px 0px #ffffff"
                                                                                    },
                                                                                    onClick: ()=>_handleroute(types/* RetreatsTypeEnum.Online */.zZ.Online, "Yoga Teacher Training"),
                                                                                    children: "Online Yoga Training"
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col-sm-0 col-lg-1 col-12"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "row mt-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col-sm-0 col-lg-1 col-xl-2 col-12"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col-sm-12 col-lg-10 col-xl-8 col-12",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "row p-0",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: " homepage ",
                                                                        style: {
                                                                            height: 60
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                                                                            homePage: true,
                                                                            _handleChange: _handleChange,
                                                                            customSearch: "col-md-6 col-lg-6 col-12 d-flex bg-white mb-1 mb-sm-0 py-2",
                                                                            customDate: "col-md-3 col-lg-3 bg-white mt-2 mt-md-0 py-2",
                                                                            customButton: "col-md-3 col-lg-3 mt-2 mt-md-0 ",
                                                                            customSearchSuggesion: "col-12 col-md-6",
                                                                            customDateSuggestion: "col-12 col-md-6"
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col-sm-0 col-lg-1 col-12"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((Home_module_default()).featured, " mt-2"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "container",
                                    style: {
                                        position: "relative"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-sm-left text-md-center text-lg-center feature-title fw-bold mb-2 ",
                                            children: "Featured Yoga Retreats"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mb-2 p-0 text-sm-left text-md-center text-lg-center fw-400 feature-paragraph brownish-grey",
                                            children: "Take a break from life and choose from our extraordinary range of retreats that will soothe your soul."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((Home_module_default()).btn_container, " d-none d-sm-none d-md-block d-lg-block "),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "btn btn-outline-primary fw-500 rounded-pill fs-12 px-4 btnHoverNew",
                                                onClick: ()=>handleFeatured(1, "Yoga Retreat"),
                                                children: "View All"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row mt-3 mt-md-5",
                                            children: data === null || data === void 0 ? void 0 : (_data_featuredRetreats = data.featuredRetreats) === null || _data_featuredRetreats === void 0 ? void 0 : _data_featuredRetreats.slice(0, 4).map((item, index)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(product_card/* default */.Z, {
                                                    retreatId: item.retreatId,
                                                    wishlistId: item.wishlists,
                                                    type: item.activity,
                                                    overview: item.title,
                                                    price: item.price,
                                                    reviewScore: item.rating,
                                                    noOfReviews: item.numberOfReviews,
                                                    image: item.file,
                                                    coupon: item.couponAvailble,
                                                    gift: item.freeGift,
                                                    popular: item.popular,
                                                    seoTitle: item.seoTitle,
                                                    seoActivityTitle: item.seoActivityTitle
                                                }, index);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-12 mt-0 d-flex align-items-center justify-content-center d-sm-flex d-md-none d-lg-none",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "btn btn-outline-primary fw-500 rounded-pill fs-12 px-4 btnHoverNew",
                                                onClick: ()=>handleFeatured(1, "Yoga Retreat"),
                                                children: "View All"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                id: "byr-why-choose-us",
                                className: "bg-footer-grey",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-lg-12",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "text-sm-left text-md-center text-lg-center feature-title fw-bold textUpperCase",
                                                        children: "Why Use Book Your Retreats?"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-sm-left text-md-center text-lg-center feature-paragraph fw-400 mb-4 paragraph",
                                                        children: "We promise to deliver the best & most authentic retreats. Professional trainers offer these retreats with immense knowledge & experience."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-lg-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "byr-why-choose-box",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "../images/byr-best-price.svg",
                                                            alt: "",
                                                            className: "byr-why-choose-image"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: "byr-why-choose-heading",
                                                            children: "Guaranteed Best Prices"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "byr-why-choose-text",
                                                            children: "Hosts offer less price to be listed on our website, saving a lot for you."
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-lg-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "byr-why-choose-box",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "../images/byr-cancellation-policy.svg",
                                                            alt: "",
                                                            className: "byr-why-choose-image"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: "byr-why-choose-heading",
                                                            children: "Easy & Free Cancellation Policy"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "byr-why-choose-text",
                                                            children: "Our cancellation policy is FREE, effortless & suitable for all."
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-lg-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "byr-why-choose-box",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "../images/byr-no-charging-fee.svg",
                                                            alt: "",
                                                            className: "byr-why-choose-image"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: "byr-why-choose-heading",
                                                            children: "No Extra Booking Fee"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "byr-why-choose-text",
                                                            children: "There is absolutely no booking fee if you book through us."
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-lg-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "byr-why-choose-box",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "../images/byr-referral.svg",
                                                            alt: "",
                                                            className: "byr-why-choose-image"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: "byr-why-choose-heading",
                                                            children: "Amazing Referral Revenue"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "byr-why-choose-text",
                                                            children: "Unlock great opportunities & generate easy passive income."
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((Home_module_default()).featured, " "),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "container",
                                    style: {
                                        position: "relative"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-sm-left text-md-center text-lg-center feature-title fw-bold mb-2 ",
                                            children: "Featured Yoga Teacher Trainings"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm-left text-md-center text-lg-center feature-paragraph fw-400 mb-2 brownish-grey",
                                            children: "Go deeper into your practice and experience an immersive teacher training program."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((Home_module_default()).btn_container, " d-none d-md-block"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "btn btn-outline-primary fw-500 rounded-pill fs-12 px-4 btnHoverNew",
                                                onClick: ()=>handleFeatured(1, "Yoga Teacher Training"),
                                                children: "View All"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row mt-3 mt-md-5",
                                            children: data === null || data === void 0 ? void 0 : (_data_featuredTeacherTraining = data.featuredTeacherTraining) === null || _data_featuredTeacherTraining === void 0 ? void 0 : _data_featuredTeacherTraining.slice(0, 4).map((item, index)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(product_card/* default */.Z, {
                                                    retreatId: item.retreatId,
                                                    wishlistId: item.wishlists,
                                                    type: item.activity,
                                                    overview: item.title,
                                                    price: item.price,
                                                    reviewScore: item.rating,
                                                    noOfReviews: item.numberOfReviews,
                                                    image: item.file,
                                                    coupon: item.couponAvailble,
                                                    gift: item.freeGift,
                                                    popular: item.popular,
                                                    seoTitle: item.seoTitle,
                                                    seoActivityTitle: item.seoActivityTitle
                                                }, index);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-12 mt-0 d-flex align-items-center justify-content-center d-sm-flex d-md-none d-lg-none",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "btn btn-outline-primary fw-500 rounded-pill fs-12 px-4 btnHoverNew",
                                                onClick: ()=>handleFeatured(1, "Yoga Teacher Training"),
                                                children: "View All"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12 bg-footer-grey py-4 py-sm-4 py-md-5 py-lg-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "container",
                                    style: {
                                        position: "relative"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-sm-left text-md-center text-lg-center feature-title fw-bold textUpperCase",
                                            children: "Safe Travel, Unique Experiences"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm-left text-md-center text-lg-center feature-paragraph fw-400 mb-2 paragraph",
                                            children: "Indulge in unique experiences and travel to refreshing yoga retreats at your favorite destinations."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UniqueExperiencesSec, {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12 bg-white py-3 py-sm-3 py-md-5 py-lg-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "container",
                                    style: {
                                        position: "relative"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-sm-left text-md-center text-lg-center feature-title fw-bold textUpperCase",
                                            children: "Discover Retreats across all styles"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "text-sm-left text-md-center text-lg-center feature-paragraph fw-400 brownish-grey",
                                            children: "Choose from a variety of retreats across all styles at one destination!"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscoverRetreats_, {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((Home_module_default()).cta_section, " py-5"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "container py-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "m-0",
                                            children: "Retreats"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                            className: " fw-bold m-0 text-white textUpperCase",
                                            children: [
                                                "There’s so much ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                " that you can do on a retreat!"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-2 fw-400 textUpperCase",
                                            children: "Activities and accommodations"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "btn-light py-2 rounded border-0 fw-semibold px-3 fs-15 paragraph",
                                            onClick: ()=>_handleroute(null, "Yoga Retreat"),
                                            children: "Learn More"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewBlock/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StillSearching/* default */.Z, {})
                        ]
                    })
                })
            ]
        });
    }
}


/***/ }),

/***/ 10682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const defaultProps = {
  fluid: false
};
const Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  fluid,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'container');
  const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, fluid ? `${prefix}${suffix}` : prefix)
  });
});
Container.displayName = 'Container';
Container.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Container);

/***/ }),

/***/ 34051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const Row = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const decoratedBsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'row');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const minBreakpoint = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapMinBreakpoint */ .zG)();
  const sizePrefix = `${decoratedBsPrefix}-cols`;
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let cols;

    if (propValue != null && typeof propValue === 'object') {
      ({
        cols
      } = propValue);
    } else {
      cols = propValue;
    }

    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, decoratedBsPrefix, ...classes)
  });
});
Row.displayName = 'Row';
/* harmony default export */ __webpack_exports__["Z"] = (Row);

/***/ }),

/***/ 57632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_browser_v4; }
});

;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ var esm_browser_native = ({
  randomUUID
});
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = ((/* unused pure expression or super */ null && (stringify)));
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js




function v4(options, buf, offset) {
  if (esm_browser_native.randomUUID && !buf && !options) {
    return esm_browser_native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,9278,7885,5120,1664,4662,1440,9859,4750,1961,1688,5310,5670,9980,6574,5340,7820,5737,3721,1375,1887,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);